import { Component, OnInit } from '@angular/core';
import { NavigationExtras, Router } from '@angular/router';
import { APIService } from 'src/app/shared/service/api.service';
import { MenuService } from 'src/app/shared/service/menu.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss']
})
export class MenuComponent implements OnInit {

  isMenuOpen = false; // Estado do menu
  activeMenu: string | null = null;
  linkCatalogoPdf = environment.baseApiUrl + '/catalogopdf';
  linkDadosAtualizadosPdf = environment.baseApiUrl + '/relatorio-dados-atualizadospdf';
  encoding = 'ISO-8859-1';

  constructor(
    private menuService: MenuService,
    private router: Router,
    private api: APIService) {

  }

  ngOnInit() {
    // Assina o estado do menu
    this.menuService.menuState$.subscribe((state) => {
      this.isMenuOpen = state;
    });
  }

  // Fecha o menu
  closeMenu() {
    this.menuService.toggleMenu();
  }

  // Para ajuste de menu expansível
  toggleMenu(menu: string) {
    this.activeMenu = this.activeMenu === menu ? null : menu;
    localStorage.setItem('activeMenu', this.activeMenu || '');
  }

  linkApresentacao() {
    this.router.navigate(['/apresentacao']);
    this.closeMenu();
  }

  linkFAQ() {
    this.router.navigate(['/faq']);
    this.closeMenu();
  }

  linkPrincipal() {
    this.router.navigate(['/']);
    this.closeMenu();
  }

  linkExpediente() {
    this.router.navigate(['/expediente']);
    this.closeMenu();
  }

  linkCursos() {
    this.router.navigate(['/cursos']);
    this.closeMenu();
  }

  linkCursosConvergentes() {
    this.router.navigate(['/cursos/mudaram-nome-tabela-convergencia']);
    this.closeMenu();
  }

  linkCursosSubmissao() {
    this.router.navigate(['/cursos/tabela-submissao']);
    this.closeMenu();
  }

  linkSugestao() {
    this.router.navigate(['/envie-sugestao']);
    this.closeMenu();
  }

  linkLegislacao() {
    this.router.navigate(['/legislacao']);
    this.closeMenu();
  }

  linkCursoEixo() {
    const navigationExtras: NavigationExtras = {
      fragment: 'cursoPorEixo'
    };
    this.router.navigate(['/'], navigationExtras);
    this.closeMenu();
  }

  downloadCsvCatalogoCncst() {
    this.api.getDownloadCsvCatalogoCncst(this.encoding)
      .subscribe((data: any) => {
        const blob = new Blob([data], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'catalogo_cncst.csv';
        link.click();
      },
        (error) => {
          console.error('Erro ao baixar o CSV de catálogo do Cncst.', error);
        });
  }
}
